import { render, staticRenderFns } from "./PreassessmentsEdit.vue?vue&type=template&id=6825c106&"
import script from "./PreassessmentsEdit.vue?vue&type=script&lang=js&"
export * from "./PreassessmentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./PreassessmentsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports